// extracted by css-extract-rspack-plugin
export default {"charts":"T4TEB6xZy9Il05d_","table_row":"tcbLp71wpSwgnFES","table_cell":"dolZeXT9iEOAi9VA","after_sales_title":"w7OVfhlD5gF3BtLr","after_sales_padding":"zwH5icjkYYBxw3b5"};